import React from 'react';
import { AgencyConversationsSettings } from '../components/AgencyConversationsSettings/AgencyConversationsSettings';
import { CallSettings } from '../components/CallSettings/CallSettings';
import { DigitalAlertsSettings } from '../components/DigitalAlertsSettings/DigitalAlertsSettings';
import { KeywordSettings } from '../components/KeywordSettings/KeywordSettings';
import { TextMessagingSettings } from '../components/TextMessagingSettings/TextMessagingSettings';
import styles from './app.module.css';

// The settings section renders a single page; it is the index route of the
// /admin/settings layout in the consolidated route table (app/Main.tsx).
const SettingsPage = () => {
  return (
    <>
      <h2 className={styles.title}>Notifications</h2>
      <div className={styles.description}>
        Configure agency-wide notification preferences for all incoming
        emergency traffic. Manage audio and visual notification settings to to
        customize how 911 calls, text sessions, and digital data are presented
        to agents.
      </div>
      <CallSettings />
      <TextMessagingSettings />
      <AgencyConversationsSettings />
      <DigitalAlertsSettings />
      <KeywordSettings />
    </>
  );
};

export default SettingsPage;
